import React, { useEffect, useRef, useState } from "react";
import { TextInput } from "../../form/inputs";
import { CiCircleInfo } from "react-icons/ci";
import { Tooltip } from "react-tooltip";
import ToggleBtn from "../../button/ToggleBtn";
import { Select } from "../../form/inputs";
import TimeRangePicker12 from "../../ui/TimeRangePicker12";
import PrimaryBtn from "../../button/PrimaryBtn";
import UploadTriggerCard from "../../upload/UploadTriggerCard";
import GalleryImg from "../../../assets/images/svgs/other/uploadImg.svg";
import UploadIcon from "../../../assets/images/svgs/other/Uploadicon.svg";
import PhotoLibraryModal from "../../Modals/PhotoLibraryModal";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  addOrUpdateService,
  getCurrency,
  getServiceDetails,
  getTimeZone,
  otherServiceImages,
} from "../../../redux/thunks/serviceRegThunk.js";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import SortableImageItem from "../../upload/SortablleImageItem";  
import { getProfileDetail } from "../../../redux/thunks/profileThunk.js";

const Service = ({ setTab }) => {
  const dispatch = useDispatch();
  const [showLibrary, setShowLibrary] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [currencyId, setCurrencyId] = useState("");
  const [timezonedid, setTimezoneid] = useState("");
  const [showUploadOptions, setShowUploadOptions] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedZone, setSelectedZone] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [countryId, setCountryId] = useState("");
  const [serDescrip, setSerDescrip] = useState("");
  const [toggleValue, setToggleValue] = useState(0);
  const [isVeg, setIsVeg] = useState(false);
  const fileInputRef = useRef(null);
  const [isPrefilled, setIsPrefilled] = useState(false);
  const [isTimezonePrefilled, setIsTimezonePrefilled] = useState(false);
  const [ServiceDetail, setServiceDetail] = useState("");
  const {
    currencies: currencyFromApi,
    timezones: timeZoneFromApi,
    isServiceLoading,
  } = useSelector((state) => state.setService);

  const [lunchstart, setLunchStart] = useState({
    hour: "",
    minute: "",
    period: "AM",
  });

  const [lunchend, setLunchEnd] = useState({
    hour: "",
    minute: "",
    period: "PM",
  });
  const [dinnerstart, setDinnerStart] = useState({
    hour: "",
    minute: "",
    period: "AM",
  });

  const [dinnerend, setDinnerEnd] = useState({
    hour: "",
    minute: "",
    period: "PM",
  });

  // Fetch profile once
  useEffect(() => {
    dispatch(getProfileDetail())
      .unwrap()
      .then((res) => {
        const country_id = res.data?.country_id;
        // console.log("The country id is :", country_id);
        setCountryId(country_id);
      })
      .catch((err) => {
        // console.log("Profile fetch error:", err);
      });
  }, [dispatch]);

  // Fetch currency & timezone AFTER countryId is available
  useEffect(() => {
    if (!countryId) return;

    dispatch(getCurrency());  

    dispatch(getTimeZone({ country_id: countryId }))
      .unwrap()
      .then((res) => {
        if (!res.data?.length) return;

        if (!timezonedid) {
          setTimezoneid(res.data[0].id);
          setSelectedZone(res.data[0].name);
        }
      });
  }, [dispatch, countryId]);

  const currencies = currencyFromApi?.map((cu) => ({
    value: cu.id,
    label: `${cu.country_name} (${cu.currency_code}) (${cu.currency_symbol})`,
  }));

  // console.log("the currencies id are :", setSelectedCurrency.id);

  // const selectedCountry = currencies.find((c) => c.value === selectedCurrency);

  const timezones = timeZoneFromApi?.map((time) => {
    return {
      id: time.id,
      value: time.name,
      label: time.name,
    };
  });

  // console.log("the timezones are :", timezones);

  const [serviceImages, setServiceImages] = useState([]);

  useEffect(() => {
    return () => {
      serviceImages.forEach((img) => {
        if (img.source === "upload" && img.preview?.startsWith("blob:")) {
          URL.revokeObjectURL(img.preview);
        }
      });
    };
  }, [serviceImages]);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, {
      activationConstraint: { delay: 200, tolerance: 5 },
    }),
  );

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;

    setServiceImages((prev) => {
      const draggedIndex = prev.findIndex((img) => img.id === active.id);
      const overIndex = prev.findIndex((img) => img.id === over.id);

      // Make a copy of the array
      const newArr = [...prev];

      // Remove the dragged item
      const [dragged] = newArr.splice(draggedIndex, 1);

      // Insert it at the new position
      newArr.splice(overIndex, 0, dragged);

      // Ensure the first image is always marked as cover
      newArr.forEach((img, index) => {
        img.isCover = index === 0;
      });

      return newArr;
    });
  };

  const handleDeviceUpload = (e) => {
    const files = Array.from(e.target.files);

    const MAX_IMAGES = 10;
    const MAX_SIZE = 5 * 1024 * 1024; // 5MB
    const ALLOWED_TYPES = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/webp",
    ];

    if (serviceImages.length + files.length > MAX_IMAGES) {
      toast.error("Maximum 10 images allowed");
      e.target.value = "";
      return;
    }

    const validFiles = [];

    files.forEach((file) => {
      // Size validation
      if (file.size > MAX_SIZE) {
        toast.error(`${file.name} exceeds 5MB limit`);
        return;
      }

      // Type validation
      if (!ALLOWED_TYPES.includes(file.type)) {
        toast.error(
          `${file.name} is not supported. Only JPG, JPEG, PNG, WEBP allowed`,
        );
        return;
      }

      validFiles.push({
        id: crypto.randomUUID(),
        source: "upload",
        file,
        preview: URL.createObjectURL(file),
      });
    });

    if (validFiles.length > 0) {
      setServiceImages((prev) => [...prev, ...validFiles]);
    }

    // Reset input (important for re-uploading same file)
    e.target.value = "";
  };

  const from24Hour = (time) => {
    if (!time) return { hour: "", minute: "", period: "AM" };

    let [hour, minute] = time.split(":");
    hour = parseInt(hour, 10);

    const period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    return {
      hour: String(hour),
      minute: String(minute),
      period,
    };
  };

  useEffect(() => {
    dispatch(getServiceDetails())
      .unwrap()
      .then((res) => {
        const data = res?.data;
        if (!data) return;

        setServiceDetail(data);

        // ✅ Basic Fields
        setServiceName(data.service_name || "");
        setSerDescrip(data.service_description || "");
        setToggleValue(data.is_pure_veg_food ? 1 : 0);
        setIsVeg(!!data.is_pure_veg_food);

        // ✅ Currency & Timezone
        if (data.currency_id) {
          setCurrencyId(data.currency_id);

          const selectedCur = currencyFromApi?.find(
            (c) => c.id === data.currency_id,
          );

          if (selectedCur) {
            setSelectedCurrency(selectedCur.country_name);
          }
        }

        if (data.timezone_id) {
          setTimezoneid(data.timezone_id);

          const selectedTz = timeZoneFromApi?.find(
            (t) => t.id === data.timezone_id,
          );

          if (selectedTz) {
            setSelectedZone(selectedTz.name);
          }
        }

        // ✅ Time Prefill
        setLunchStart(from24Hour(data.lunch_time_from));
        setLunchEnd(from24Hour(data.lunch_time_to));
        setDinnerStart(from24Hour(data.dinner_time_from));
        setDinnerEnd(from24Hour(data.dinner_time_to));

        // ✅ Images Prefill
        if (data.service_other_images?.length) {
          const sortedImages = [...data.service_other_images].sort(
            (a, b) => b.is_cover_image - a.is_cover_image,
          );

          const mappedImages = sortedImages.map((img) => ({
            id: crypto.randomUUID(),
            preview: img.image_url,
            type: img.type, // gallery
            imageId: img.id,
            source: "gallery",
          }));

          setServiceImages(mappedImages);
        }
      });
  }, [dispatch]);

  useEffect(() => {
    if (isPrefilled) return;
    if (!currencyFromApi?.length) return;
    if (!currencyId) return;

    const matched = currencyFromApi.find((cur) => cur.id === currencyId);

    if (matched) {
      setSelectedCurrency(matched.country_name);
      setCountryId(matched.country_id);
      setIsPrefilled(true); // 🔥 important
    }
  }, [currencyFromApi, currencyId, isPrefilled]);

  useEffect(() => {
    if (isTimezonePrefilled) return;
    if (!timeZoneFromApi?.length) return;
    if (!timezonedid) return;

    const matched = timeZoneFromApi.find((tz) => tz.id === timezonedid);

    if (matched) {
      setSelectedZone(matched.name);
      setIsTimezonePrefilled(true);
    }
  }, [timeZoneFromApi, timezonedid, isTimezonePrefilled]);

  const validatePayload = () => {
    const errors = {};

    if (!serviceName?.trim()) errors.serviceName = "Service name is required";

    if (!selectedCurrency) errors.currency = "Currency is required";

    if (!selectedZone) errors.timezone = "Timezone is required";

    if (!serviceImages.length) {
      errors.images = "At least one image is required";
    }

    if (serviceImages.length > 10) {
      errors.images = "You can upload up to 10 images only";
    }

    /* ================= TIME VALIDATION ================= */

    const lunchStartMin = toMinutes(lunchFrom);
    const lunchEndMin = toMinutes(lunchTo);
    const dinnerStartMin = toMinutes(dinnerFrom);
    const dinnerEndMin = toMinutes(dinnerTo);

    // Lunch invalid
    if (lunchStartMin >= lunchEndMin) {
      errors.lunch = "Lunch end time must be greater than lunch start time";
    }

    // Dinner invalid
    if (dinnerStartMin >= dinnerEndMin) {
      errors.dinner = "Dinner end time must be greater than dinner start time";
    }

    // Dinner must be after lunch
    if (dinnerStartMin <= lunchEndMin) {
      errors.dinner =
        "Dinner time must be after lunch time. Please add proper timing";
    }

    return errors;
  };

  const to24Hour = ({ hour, minute, period }) => {
    let h = parseInt(hour, 10);

    if (period === "PM" && h !== 12) h += 12;
    if (period === "AM" && h === 12) h = 0;

    return `${String(h).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
  };
  const toMinutes = (timeStr) => {
    if (!timeStr) return 0;
    const [h, m] = timeStr.split(":").map(Number);
    return h * 60 + m;
  };

  const lunchFrom = to24Hour(lunchstart);
  const lunchTo = to24Hour(lunchend);
  const dinnerFrom = to24Hour(dinnerstart);
  const dinnerTo = to24Hour(dinnerend);

  const handleNextBtn = async () => {
    const errors = validatePayload();
    setFormErrors(errors);
    if (Object.keys(errors).length) return;

    try {
      // console.log("🔵 SERVICE IMAGES (RAW):", serviceImages);

      // ===============================
      // 1️⃣ Only DEVICE uploads
      // ===============================
      const uploadImages = serviceImages.filter(
        (img) => img.source === "upload",
      );

      // console.log("🟡 UPLOAD IMAGES:", uploadImages);

      let uploadedImageNames = [];

      if (uploadImages.length > 0) {
        const fd = new FormData();
        fd.append("type", "service_provider/other_images");

        uploadImages.forEach((img, i) => {
          // console.log(`📤 Uploading file ${i}:`, img.file.name);
          fd.append("images[]", img.file);
        });

        const uploadRes = await dispatch(otherServiceImages(fd)).unwrap();

        // console.log("🟢 UPLOAD API RESPONSE:", uploadRes);

        uploadedImageNames = uploadRes?.data?.temp_images || [];

        // console.log("🟢 UPLOADED IMAGE NAMES:", uploadedImageNames);
      }

      let uploadIndex = 0;

      // -------- COVER IMAGE ----------
      const cover = serviceImages[0];
      // console.log("🟣 COVER IMAGE RAW:", cover);

      const service_cover_images =
        cover.type === "gallery"
          ? {
              type: "gallery",
              id: cover.imageId,
            }
          : {
              type: "upload",
              name: uploadedImageNames[uploadIndex++] || null,
            };

      // console.log("🟣 COVER PAYLOAD:", service_cover_images);

      // -------- OTHER IMAGES ----------
      const service_other_images = serviceImages.slice(1).map((img, idx) => {
        // console.log(`🟠 OTHER IMAGE ${idx}:`, img);

        if (img.type === "gallery") {
          return {
            type: "gallery",
            id: img.imageId,
          };
        }

        return {
          type: "upload",
          name: uploadedImageNames[uploadIndex++] || null,
        };
      });

      // console.log("🟠 OTHER IMAGES PAYLOAD:", service_other_images);

      // ===============================
      // 3️⃣ Final payload
      // ===============================
      const payload = {
        service_name: serviceName,
        service_description: serDescrip,
        country_id: countryId,
        currency_id: currencyId,
        timezone_id: timezonedid,
        is_pure_veg_food: toggleValue,
        lunch_time_from: lunchFrom,
        lunch_time_to: lunchTo,
        dinner_time_from: dinnerFrom,
        dinner_time_to: dinnerTo,
        service_cover_images,
        service_other_images,
        removed_other_images: [],
      };

      // console.log("🚀 FINAL PAYLOAD:", payload);

      try {
        const res = await dispatch(addOrUpdateService(payload)).unwrap();

        toast.success("Service saved successfully");

        const isRegistrationCompleted =
          res?.data?.is_registration_completed ?? false;

        localStorage.setItem(
          "is_add_reg",
          JSON.stringify(isRegistrationCompleted),
        );

        setTab(1);
      } catch (err) {
        console.error("❌ ERROR:", err);
        toast.error(err?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("❌ ERROR:", err);
      toast.error(err?.message || "Something went wrong");
    }
  };

  return (
    <>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        {/* ================= Title ================= */}
        <div className="text-center space-y-2 max-w-2xl mx-auto">
          <h1 className="text-[#191919] text-2xl md:text-3xl font-bold">
            Add Your Service Identity
          </h1>
          <p className="text-[#747474] text-sm sm:text-base">
            Give your tiffin service a name, add photos, and write a short
            description so customers know who you are.
          </p>
        </div>

        {/* ================= Service Name ================= */}
        <div className="max-w-5xl mx-auto">
          <TextInput
            required={true}
            label="Tiffin service name"
            name="servicename"
            value={serviceName}
            onChange={(e) => setServiceName(e.target.value)}
            placeholder="Enter Tiffin Service Name"
          />
          {formErrors.serviceName && (
            <p className="text-red-500 text-xs mt-1">
              {formErrors.serviceName}
            </p>
          )}
        </div>

        {/* ================= Upload Heading ================= */}
        <div className="flex gap-2 items-center justify-center sm:justify-start max-w-5xl mx-auto">
          <p className="text-sm sm:text-base">
            Upload tiffin service photographs
          </p>
          <CiCircleInfo
            size={18}
            className="cursor-pointer text-gray-500"
            data-tooltip-id="photo-info"
            data-tooltip-content="Upload photo of your best dishes"
          />
          <Tooltip
            id="photo-info"
            place="top"
            className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[220px] text-center"
          />
        </div>

        {/* ================= Upload Card ================= */}
        <div className="max-w-5xl mx-auto">
          <UploadTriggerCard
            icon={GalleryImg}
            text="Upload your service logo or brand photo"
            buttonText="Upload"
            required={true}
            onClick={() => setShowUploadOptions(true)}
          />
          {formErrors.images && (
            <p className="text-red-500 text-xs mt-1">{formErrors.images}</p>
          )}
        </div>

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple
          className="hidden"
          onChange={handleDeviceUpload}
        />

        {/* ================= Images Preview ================= */}

        {serviceImages.length > 0 && (
          <div className="max-w-5xl mx-auto">
            <DndContext
              sensors={sensors}
              collisionDetection={closestCenter}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={serviceImages.map((i) => i.id)}
                strategy={rectSortingStrategy}
              >
                <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 gap-4 touch-none">
                  {serviceImages.map((item, i) => (
                    <SortableImageItem
                      key={item.id}
                      id={item.id}
                      img={item}
                      isCover={i === 0}
                      onRemove={() =>
                        setServiceImages((prev) =>
                          prev.filter((_, idx) => idx !== i),
                        )
                      }
                    />
                  ))}
                </div>
              </SortableContext>
            </DndContext>

            <p className="mt-3 text-sm text-gray-600">
              Note: The first image will appear as your cover image.You can
              click and hold to drag images and change their order.
            </p>
          </div>
        )}

        {/* ================= Details Grid ================= */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {/* Description */}
          <div className="md:col-span-2">
            <div className="flex gap-2 items-center mb-1">
              <p>Description</p>
              <CiCircleInfo
                size={18}
                className="cursor-pointer text-gray-500"
                data-tooltip-id="desc-info"
                data-tooltip-content="Add a short description about your tiffin - plans, offers, quality etc"
              />
              <Tooltip
                id="desc-info"
                place="top"
                className="!text-xs !bg-black !px-3 !py-2 !rounded-lg !max-w-[240px] text-center"
              />
            </div>
            <TextInput
              name="description"
              placeholder="Enter Description"
              value={serDescrip}
              onChange={(e) => setSerDescrip(e.target.value)}
            />
            {formErrors.serDescrip && (
              <p className="text-red-500 text-xs mt-1">
                {formErrors.serDescrip}
              </p>
            )}
          </div>

          {/* Veg Toggle */}
          <div className="flex items-center justify-between border rounded-lg px-4 py-3 md:col-span-2">
            <p className="text-[#191919] text-sm sm:text-base">
              We offer pure vegetarian food.
            </p>

            <ToggleBtn
              isOn={isVeg}
              size={40}
              onChange={(val) => {
                setIsVeg(val);
                setToggleValue(val ? 1 : 0); // agar API ke liye chahiye
              }}
            />
          </div>

          {/* Currency & Timezone */}
          <div>
            <Select
              required
              label="Currency"
              name="currency"
              value={currencyId} // use the ID
              onChange={(selectedId) => {
                setCurrencyId(selectedId);

                const selected = currencyFromApi.find(
                  (c) => c.id === selectedId,
                );

                if (selected) {
                  setCountryId(selected.country_id);
                  localStorage.setItem("currency", selected.currency_symbol);
                }
              }}
              options={currencies}
              displaySelected="label"
              clearable
            />
            {formErrors.currency && (
              <p className="text-red-500 text-xs mt-1">{formErrors.currency}</p>
            )}
          </div>
          <div>
            <Select
              required={true}
              label="Timezone"
              name="Timezone"
              value={selectedZone}
              onChange={(selectedValue) => {
                setSelectedZone(selectedValue);

                const selectedZoneObj = timezones.find(
                  (tz) => tz.value === selectedValue,
                );

                if (selectedZoneObj) {
                  setTimezoneid(selectedZoneObj.id);
                }
              }}
              options={timezones}
            />
            {formErrors.timezone && (
              <p className="text-red-500 text-xs mt-1">{formErrors.timezone}</p>
            )}
          </div>
          {/* Time Pickers */}
          <div>
            <TimeRangePicker12
              label="Lunch Serving Time"
              startTime={lunchstart}
              endTime={lunchend}
              onStartChange={setLunchStart}
              onEndChange={setLunchEnd}
            />
            {formErrors.lunch && (
              <p className="text-red-500 text-xs mt-1">{formErrors.lunch}</p>
            )}
          </div>

          <div>
            <TimeRangePicker12
              label="Dinner Serving Time"
              startTime={dinnerstart}
              endTime={dinnerend}
              onStartChange={setDinnerStart}
              onEndChange={setDinnerEnd}
            />
            {formErrors.dinner && (
              <p className="text-red-500 text-xs mt-1">{formErrors.dinner}</p>
            )}
          </div>
        </div>
        <div className="flex flex-col-reverse px-10 sm:flex-row sm:items-center md:justify-between gap-4 pt-6 mt-8 max-w-7xl mx-auto">
          <p
            onClick={() => setTab(1)}
            className="text-[#FF6943] text-sm sm:text-base text-center sm:text-right cursor-pointer hover:underline"
          >
            Skip
          </p>

          <PrimaryBtn
            btnName="Next"
            clickEvent={handleNextBtn}
            extraClass="w-full  px-10"
            isLoading={isServiceLoading}
          />
        </div>
      </div>

      {showUploadOptions && (
        <div className="fixed inset-0 bg-[#0F172A]/60 flex items-center justify-center z-50 animate-fadeIn">
          <div className="relative w-full max-w-lg mx-4">
            {/* Modal Card */}
            <div className="relative bg-white rounded-3xl p-8 shadow-[0_25px_60px_-15px_rgba(0,0,0,0.25)] border border-gray-100">
              {/* Accent Top Bar */}

              {/* Title Section */}
              <div className="text-center mb-8">
                <h2 className="text-2xl font-semibold text-gray-900 tracking-tight">
                  Upload Photos
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                  Choose how you want to add your images
                </p>
              </div>

              {/* Options */}
              <div className="space-y-4">
                {/* Upload From Device */}
                <button
                  onClick={() => {
                    setShowUploadOptions(false);
                    fileInputRef.current.click();
                  }}
                  className="group relative w-full flex items-center justify-between px-6 py-5 rounded-2xl 
                             bg-gradient-to-r from-[#FF7043]/20 to-[#FF5722]/50 
                             text-white font-medium shadow-lg 
                             "
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/20">
                      <img
                        src={UploadIcon}
                        alt="uploadIcon"
                        className="w-6 h-6"
                      />
                    </div>
                    <span className="text-base text-black">
                      Upload from device
                    </span>
                  </div>

                  <span className="opacity-70 group-hover:translate-x-1 transition-transform duration-300">
                    →
                  </span>
                </button>

                {/* Choose From Library */}
                <button
                  onClick={() => {
                    setShowUploadOptions(false);
                    setShowLibrary(true);
                  }}
                  className="group w-full flex items-center justify-between px-6 py-5 rounded-2xl 
                             border border-gray-200 bg-white 
                             text-gray-700 font-medium 
                             "
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gray-100">
                      <img
                        src={GalleryImg}
                        alt="galleryicon"
                        className="w-6 h-6"
                      />
                    </div>
                    <span className="text-base">Choose from photo library</span>
                  </div>

                  <span className="text-gray-400 group-hover:translate-x-1 transition-transform duration-300">
                    →
                  </span>
                </button>
              </div>

              {/* Footer */}
              <div className="mt-8 text-center">
                <button
                  onClick={() => setShowUploadOptions(false)}
                  className="text-sm text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ================= PHOTO LIBRARY ================= */}
      {showLibrary && (
        <PhotoLibraryModal
          selectedImages={serviceImages
            .filter((img) => img.type === "gallery")
            .map((img) => img.imageId)}
          onClose={() => setShowLibrary(false)}
          onToggleSelect={(image) => {
            setServiceImages((prev) => {
              const MAX_IMAGES = 10;
              const exists = prev.find(
                (img) => img.type === "gallery" && img.imageId === image.id,
              );

              if (prev.length >= MAX_IMAGES) {
                toast.error("Maximum 10 images allowed");
                return prev;
              }
              // ❌ Deselect
              if (exists) {
                return prev.filter((img) => img.imageId !== image.id);
              }

              // ✅ Select
              return [
                ...prev,
                {
                  id: crypto.randomUUID(),
                  preview: image.image,
                  type: "gallery",
                  imageId: image.id,
                },
              ];
            });
          }}
        />
      )}
    </>
  );
};

export default Service;
